module.exports = __webpack_public_path__ + "static/comLogo.a14c9b71.png";